import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import Journey from "./pages/Journey";
import Legal from "./pages/Legal";
import StaffLogin from "./pages/staff/StaffLogin";
import StaffLayout, { AdminOnly } from "./pages/staff/StaffLayout";
import Leads from "./pages/staff/Leads";
import Funnel from "./pages/staff/Funnel";
import Team from "./pages/staff/Team";
import Cities from "./pages/staff/Cities";
import Settings from "./pages/staff/Settings";

const Staff = ({ children }) => <AuthProvider>{children}</AuthProvider>;

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Journey />} />
        {["privacy", "terms", "disclaimer"].map((p) => <Route key={p} path={`/${p}`} element={<Legal page={p} />} />)}
        <Route path="/staff" element={<Staff><StaffLogin /></Staff>} />
        <Route element={<Staff><StaffLayout /></Staff>}>
          <Route path="/staff/leads" element={<Leads />} />
          <Route path="/staff/funnel" element={<AdminOnly><Funnel /></AdminOnly>} />
          <Route path="/staff/team" element={<AdminOnly><Team /></AdminOnly>} />
          <Route path="/staff/cities" element={<AdminOnly><Cities /></AdminOnly>} />
          <Route path="/staff/settings" element={<AdminOnly><Settings /></AdminOnly>} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
